import { _history, _guest, _users } from '../util/seed'
import db from '../util/mock/db'
const SEED_DB_REQUEST = 'db/SEED_DB_REQUEST'
const SEED_DB_SUCCESS = 'db/SEED_DB_SUCCESS'

const initialState = [];

export default (settings = initialState, action) => {
  switch (action.type) {
    default:
      return { ...settings }
  }
}

export const seedDb = (id) => {
  return dispatch => {
    localStorage.clear();
    dispatch({ type: SEED_DB_REQUEST });
    const promises = [];
    _guest().forEach((g) => {
      promises.push(new Promise((fulfill, reject) => {
        const pk = g.guest_id;
        const sk = g.timestamp;
        db.putItem(pk, sk, g, function (err) {
          if (err) return reject(err);
          return fulfill();
        });
      }));
    })
    _history().forEach((h) => {
      promises.push(new Promise((fulfill, reject) => {
        const pk = h.user_id;
        const sk = h.created;
        db.putItem(pk, sk, h, function (err) {
          if (err) return reject(err);
          return fulfill();
        });
      }))
    });
    _users().forEach((u) => {
      promises.push(new Promise((fulfill, reject) => {
        db.putItem('user', 'default', u, function (err) {
          if (err) return reject(err);
          return fulfill();
        });
      }))
    });
    Promise.all(promises).then(() => {
      dispatch({ type: SEED_DB_SUCCESS })
    })
  }
}


// WEBPACK FOOTER //
// ./src/reducers/settings.js